import ContactDuplicates from 'assets/js/pages/contacts/duplicates/ContactDuplicates';

const DataHygieneDuplicates = () => {
    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
                <div className="flex gap-2">
                    <h1 className="text-xl font-medium leading-snug">Duplicate contacts</h1>
                </div>
                <p className="text-sm text-gray-600">
                    Merge all data from duplicate contacts into the starred contact. Non-duplicate
                    information from non-primary selection is retained as secondary data, and will
                    remain fully accessible for viewing and editing on the contact's detail page.
                </p>
            </div>
            <ContactDuplicates />
        </div>
    );
};

export { DataHygieneDuplicates };
